import { plural } from '@cian/utils';

import { ISpecialtySchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getNewBusinessSaleSpecialtiesTitle } from '../../../../utils/getNewBusinessSaleSpecialtiesTitle';

type IGetSpecialitiesLabel = (specialties: ISpecialtySchema[]) => [string] | [string, string];

const VISIBLE_SPECIALITES_LENGTH = 3;

export const getSpecialtiesLabel: IGetSpecialitiesLabel = specialties => {
  const firstElements = specialties.slice(0, VISIBLE_SPECIALITES_LENGTH);
  const firstElementsLabel = getNewBusinessSaleSpecialtiesTitle(firstElements);

  if (firstElements.length === 1) {
    return [firstElementsLabel, 'Назначение'];
  }

  const otherElementsLength = specialties.slice(VISIBLE_SPECIALITES_LENGTH).length;

  if (!otherElementsLength) {
    return [firstElementsLabel];
  }

  const pluralOtherSpecialities = plural(otherElementsLength, ['назначение', 'назначения', 'назначений']);

  return [firstElementsLabel.concat('...'), `+${otherElementsLength} ${pluralOtherSpecialities}`];
};
